import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton, Typography } from '@mui/material';
import { CommonTexts } from 'locale/es';
import { useNavigate } from 'react-router-dom';
import { AppColors } from 'resources/AppColors';

function DeleteMenuOption({ entityId, showText, isDashboardView }) {
  const navigate = useNavigate()

  function handleDeleteModal() {
    if (isDashboardView) {
      navigate(`/dades-del-participant/contingut/patients/${entityId}/delete`, { state: { entityId } })
    } else {
      navigate(`${entityId}/delete`, { state: { entityId } })
    }
  }


  return (
    <Box onClick={handleDeleteModal} p={"6px"} sx={{ width: "100%" }} >
      <IconButton data-cy="table-delete-button" >
        <DeleteIcon sx={{ fill: AppColors.PRIMARY }} />
        {showText &&
          <Typography variant="menu_list_text" >
            {CommonTexts.DELETE}
          </Typography>
        }
      </IconButton>
    </Box>
  )
}

export default DeleteMenuOption